export default {
  SET_LOADING(state) {
    state.loadingGeral.initialize = !state.loadingGeral.initialize;
  },
  setDataEstados(state, data) {
    state.dataEstadosCidades = data;
  }
};
